"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CivicLogo = _interopRequireDefault(require("./CivicLogo"));

var _CivicLogoInverted = _interopRequireDefault(require("./CivicLogoInverted"));

var _CivicLogoAnimated = _interopRequireDefault(require("./CivicLogoAnimated"));

var _CivicLogoAnimatedInverted = _interopRequireDefault(require("./CivicLogoAnimatedInverted"));

var _CivicLogoC = _interopRequireDefault(require("./CivicLogoC"));

var _CivicLogoCAnimated = _interopRequireDefault(require("./CivicLogoCAnimated"));

var _CivicLogoCInverted = _interopRequireDefault(require("./CivicLogoCInverted"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Logo(_ref) {
  var type = _ref.type,
      alt = _ref.alt;

  switch (type) {
    case "standardLogo":
      return _react["default"].createElement(_CivicLogo["default"], {
        alt: alt
      });

    case "standardLogoInverted":
      return _react["default"].createElement(_CivicLogoInverted["default"], {
        alt: alt
      });

    case "standardLogoAnimated":
      return _react["default"].createElement(_CivicLogoAnimated["default"], {
        alt: alt
      });

    case "standardLogoAnimatedInverted":
      return _react["default"].createElement(_CivicLogoAnimatedInverted["default"], {
        alt: alt
      });

    case "squareLogo":
      return _react["default"].createElement(_CivicLogoC["default"], {
        alt: alt
      });

    case "squareLogoAnimated":
      return _react["default"].createElement(_CivicLogoCAnimated["default"], {
        alt: alt
      });

    case "squareLogoInverted":
      return _react["default"].createElement(_CivicLogoCInverted["default"], {
        alt: alt
      });

    default:
      return _react["default"].createElement(_CivicLogoAnimated["default"], {
        alt: alt
      });
  }
}

Logo.displayName = "Logo";
Logo.propTypes = {
  type: _propTypes["default"].string,
  alt: _propTypes["default"].string
};
Logo.defaultProps = {
  type: "standardLogoAnimated",
  alt: "CIVIC Logo"
};
var _default = Logo;
exports["default"] = _default;